import { Link } from 'react-router-dom'
import { motion, useReducedMotion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { cn } from '@/lib/utils'
import { homeEase } from '@/store/components/home/motion'

interface SectionActionButtonProps {
  to: string
  children: React.ReactNode
  className?: string
  /** Fade/slide in when scrolled into view (skip when parent already animates). */
  animateIn?: boolean
}

export function SectionActionButton({
  to,
  children,
  className,
  animateIn = true,
}: SectionActionButtonProps) {
  const reduceMotion = useReducedMotion()

  return (
    <motion.div
      className={cn('shrink-0', className)}
      initial={
        animateIn && !reduceMotion ? { opacity: 0, scale: 0.92, y: 8 } : false
      }
      whileInView={
        animateIn && !reduceMotion
          ? { opacity: 1, scale: 1, y: 0 }
          : undefined
      }
      viewport={animateIn ? { once: true, margin: '-40px' } : undefined}
      transition={{ duration: 0.45, ease: homeEase, delay: 0.08 }}
      whileHover={
        reduceMotion
          ? undefined
          : { scale: 1.05, y: -2, transition: { duration: 0.2, ease: homeEase } }
      }
      whileTap={reduceMotion ? undefined : { scale: 0.97 }}
    >
      <Link
        to={to}
        className="btn-primary-animated group inline-flex items-center gap-1.5 brand-radius-a px-4 py-2 text-sm font-semibold focus-ring sm:px-5 sm:py-2.5"
      >
        {children}
        <ArrowRight
          className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5"
          aria-hidden
        />
      </Link>
    </motion.div>
  )
}
